/* Replace stale app label prices with catalog prices where the option/variant mapping is verified.
   Unknown mappings show an explicit cart-total message instead of an invented quote. */
(function(){
  'use strict';
  var section=document.querySelector('[data-legacy-product]');if(!section)return;
  var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  var known=section.dataset.legacyProduct==='996-c2-suspension-package'?{
    'GT Series Front Swaybar Kit - 26.8mm (standard)': ['front-swaybar-bushing-kit-all-996-997-991-boxster-cayman',40473986433188],
    'GT Series Rear Swaybar Kit - 20.7mm': ['rear-swaybar-bushing-kit-all-996-997-991',40504390844580],
    'Front Drop Link Pair (For non-threaded dampers)': ['drop-link-pr-front-996-997-986-987-981-718-991-not-pdcc',40474218496164],
    'Rear Drop Link Pair, For OEM Shocks': ['drop-link-pr-rear-996-997-991',40504594759844],
    'Adjustable Toe Control Arm Pair': ['rear-toe-control-arm-pr',40476037120164],
    'Locking Plate Kit': ['locking-plate-kit-996-993-t-link-lkplt01',40415538249892]
  }:{};
  var prices={},loaded=false;
  function money(n){return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:section.dataset.currency||'USD'}).format(n/100);}
  function label(value){return value.split('|')[0].replace(/\s*\(\$[\d,.]+\)/g,'').trim();}
  function render(){
    var sum=0,unknown=false,count=0;
    section.querySelectorAll('#infiniteoptions-container option').forEach(function(option){
      var name=label(option.value),mapping=known[name],price=mapping?prices[mapping[1]]:undefined;
      option.textContent=name+(price!==undefined?' ('+money(price)+')':'');
      if(option.selected&&/\(\$/.test(option.value)){count++;if(price===undefined)unknown=true;else sum+=price;}
    });
    var display=section.querySelector('.tarett-package__price');
    display.textContent=!count?'Choose your parts':unknown?(loaded?'Current total shown in cart':'Loading current prices…'):money(sum);
    display.classList.toggle('tarett-package__price--message',!count||unknown);
  }
  window.TarettLegacyPricing={render:render};
  async function load(){
    var entries=Object.entries(known),index=0;
    async function worker(){while(index<entries.length){var mapping=entries[index++][1];try{var response=await fetch(root+'products/'+mapping[0]+'.js');if(!response.ok)continue;var product=await response.json(),variant=product.variants.find(function(v){return v.id===mapping[1];});if(variant)prices[variant.id]=variant.price;}catch(e){/* Never fall back to stale label prices. */}}}
    await Promise.all([worker(),worker(),worker()]);loaded=true;render();
  }
  section.addEventListener('change',render);render();load();
})();
